module.exports = __webpack_public_path__ + "static/media/illustration.7ae3e0cb.svg";